<template>
  <div id="hubungkan-akun-page">
    <page-header-component
      icon="bi bi-facebook icon-sidebar"
      title="Hubungkan Akun"
      :hide-filter="true"
    />
    <div class="row">
      <div class="col-md-12 m-b-25 px-gap">
        <div class="bg-white rounded p-3 shade">
          <h6 style="padding: 5px 0px">Akun Terhubung</h6>
          <p>
            Silahkan hubungkan akun sosial media Anda untuk mendapatkan data
            lebih banyak.
          </p>
          <div class="row m-b-10" align="center">
            <div class="col-md-4" v-if="project == null">
              <button
                aria-label=""
                class="btn btn-block btn-info btn-lg"
                type="button"
                style="background: #4267b2"
              >
                <i class="bi bi-facebook"></i>
                <span>Memeriksa data...</span>
              </button>
            </div>
            <div v-else class="col-md-4">
              <button
                v-if="facebook_login"
                aria-label=""
                class="btn btn-block btn-info btn-lg"
                type="button"
                style="background: #4267b2"
                @click="unbind('fb')"
              >
                <i class="bi bi-facebook"></i>
                <span>{{
                  project.project_detail.socmed_creds.facebook.account_name
                }}</span>
              </button>
              <facebook-login-component v-else />
            </div>
          </div>
          <p style="text-align: justify" class="hint-text fs-12">
            <b><i class="bi bi-info-circle"></i> Note: </b> Online Media
            Monitoring terhubung ke akun Facebook dan Instagram Anda secara
            eksklusif untuk mengumpulkan data yang bersifat publik. Online Media
            Monitoring tidak mengumpulkan data pribadi apa pun. Online Media
            Monitoring juga hanya meminta izin yang benar-benar diperlukan untuk
            melakukan pengumpulan data, dan tidak akan pernah digunakan untuk
            mengelola atau memposting ke Halaman Facebook, Profil, atau akun
            Instagram Anda dengan cara apa pun. Selain itu, jika tautan akun
            facebook di lepaskan pada Online Media Monitoring, itu tidak akan
            melepaskan tautan pada akun Facebook Anda. Jika ingin melepaskan
            tautan pada akun Facebook Anda, silahkan untuk mengikuti langkahnya
            <u
              @click="showModalTutor"
              class="clickable hoverable text-success font-weight-bolder"
            >
              Disini </u
            >.
          </p>
        </div>
      </div>
    </div>
    <modal-dynamic-component v-if="modal" :key="modal_key" :modal="modal" />
    <v-tour
      v-if="tour_steps.length > 0"
      name="myTour"
      :steps="tour_steps"
      :options="{ highlight: true }"
    ></v-tour>
  </div>
</template>

<script>
import $ from "jquery";
import page_header from "@/views/components/page_header.vue";
import modal_dynamic from "@/views/components/modal_dynamic.vue";
import facebook_login from "@/views/components/settings/hubungkan-akun/facebook_login.vue";
import swal from "sweetalert";
import modal_logout_fb_tutorial from "@/views/components/settings/hubungkan-akun/modal_logout_fb_tutorial.vue";

export default {
  name: "HubungkanAkun",
  title: "Settings Hubungkan Akun | Online Media Monitoring",
  components: {
    "page-header-component": page_header,
    "modal-dynamic-component": modal_dynamic,
    "facebook-login-component": facebook_login,
  },
  data() {
    return {
      tour_steps: [],
      modal: null,
      modal_key: 0,
      id_project: this.$store.getters.user.id_project,
      project: null,
      facebook_login: false,
    };
  },
  methods: {
    getProject: function () {
      let api =
        process.env.VUE_APP_API_URL + "project-detail/" + this.id_project;
      this.$http.get(api).then((response) => {
        if (response.status == 200) {
          this.project = response.data;
          if (this.project.project_detail.socmed_creds) {
            if (this.project.project_detail.socmed_creds.facebook) {
              this.facebook_login = true;
            }
          }
        }
      });
    },
    unbind: function (source) {
      let self = this;
      swal({
        title: "Apakah anda yakin akan meng-unbind akun?",
        text: "Meng-unbind akun akan mengembalikan limit data dan keyword yang bisa dimonitor.",
        icon: "warning",
        buttons: ["Tidak", "Ya"],
        dangerMode: true,
      }).then((yess) => {
        if (yess) {
          let params = {
            id_project: this.id_project,
          };
          let api = process.env.VUE_APP_API_URL + "unlink_fb";

          if (source == "twitter") {
            api = process.env.VUE_APP_API_URL + "unlink_tw";
          }
          this.$http
            .post(api, params)
            .then(function (response) {
              if (response.status == 200) {
                $("body")
                  .pgNotification({
                    style: "bar",
                    message:
                      '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Akun berhasil di-unbind.',
                    position: "top",
                    timeout: 5000,
                    type: "success",
                  })
                  .show();
                if (source == "facebook") {
                  self.facebook_login = false;
                }
                self.getProject();
              }
            })
            .catch(function () {
              $("body")
                .pgNotification({
                  style: "bar",
                  message:
                    '<i class="bi bi-x-circle"></i> <b>Error!</b> Terjadi kesalahan saat meng-unbind akun.',
                  position: "top",
                  timeout: 5000,
                  type: "danger",
                })
                .show();
            });
        }
      });
    },
    showModalTutor: function () {
      this.modal = {};
      this.modal.title = "Melepaskan Tautan Akun Facebook";
      this.modal.subtitle =
        "Berikut ini cara untuk melepaskan tautan Online Media Monitoring pada akun Facebook Anda";
      this.modal.component = modal_logout_fb_tutorial;
      this.modal_key++;
    },
  },
  created: function () {
    this.getProject();
  },
  mounted: function () {
    let v_step = [];
    v_step[0] = {
      target: "#account",
      header: {
        title: "Akun Terhubung",
      },
      content: `Menampilkan daftar akun terhubung. Anda dapat menghubungkan akun tersedia untuk mendapatkan data yang lebih banyak`,
      params: {
        placement: "bottom",
        enableScrolling: false,
      },
    };

    this.tour_steps = v_step;
  },
};
</script>

<style scoped>
@import "../../../../public/assets/plugins/bootstrap-social/bootstrap-social.css";
</style>